import { KeyOutlined } from "@ant-design/icons";
import { Button, Edit, SaveButton, Space, useForm } from "@pankod/refine-antd";
import { IResourceComponentsProps, useNotification } from "@pankod/refine-core";
import { useParams } from "@pankod/refine-react-router-v6";
import { UsersForm } from "components/forms";
import { ModalChangePassword } from "components/modals";
import { IUsers } from "interfaces";

export const UsersEdit: React.FC<IResourceComponentsProps> = () => {
  const { id } = useParams();
  const notification = useNotification();
  const { formProps, saveButtonProps, queryResult } = useForm<IUsers>({
    onMutationSuccess: (data) => {
      const error = (data as any)?.data?.error;
      if (error) {
        notification.open?.({
          message: error,
          type: "error",
        });
        return;
      }
      const message =
        (data as any)?.data?.message || "Usuário editado com sucesso.";
      notification.open?.({
        message,
        type: "success",
      });
    },
    onMutationError: (error) => {
      const message =
        (error as any)?.response?.data?.message ||
        (error as any)?.message ||
        "Erro ao editar usuário.";
      notification.open?.({
        message,
        type: "error",
      });
    },
    successNotification: false,
    errorNotification: false,
  });

  return (
    <Edit
      footerButtons={() => (
        <Space direction="horizontal">
          <ModalChangePassword
            userId={id || ""}
            trigger={<Button icon={<KeyOutlined />}>Alterar Senha</Button>}
          />

          <SaveButton {...saveButtonProps} children="Salvar" />
        </Space>
      )}
    >
      <UsersForm formProps={formProps} queryResult={queryResult} isEdit/>
    </Edit>
  );
};
